<!-- <mat-form-field appearance="standard">
  <mat-label>Filter</mat-label>
  <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input />

</mat-form-field> -->

<div class="sale-horse-list-result">

  <div class="row mt-4 mb-2">
    <div class="col-md-11 col-sm-12 text-center">

      <button type="button" #reviewBtn
              class="btn btn-outline-primary btn-review me-1 btn-sm"
              (click)="updateSaleSubmissionFilter(saleHorseSubmissionsStatusIds.IN_REVIEW,$event)"
              [ngClass]="{ active: filter.inReview }">
        In Review ({{ getFiltersCount(saleHorseSubmissionsStatusIds.IN_REVIEW)}})
      </button>

      <button type="button"
              class="btn btn-outline-primary me-1 btn-sm"
              (click)="updateSaleSubmissionFilter(saleHorseSubmissionsStatusIds.DENIED,$event)"
              [ngClass]="{ active: filter.denied }">
        Denied({{ getFiltersCount(saleHorseSubmissionsStatusIds.DENIED)}})
      </button>
      <button type="button"
              class="btn btn-outline-primary me-1 btn-sm"
              (click)="updateSaleSubmissionFilter(saleHorseSubmissionsStatusIds.APPROVED,$event)"
              [ngClass]="{ active: filter.approved }">
        Approved ({{ getFiltersCount(saleHorseSubmissionsStatusIds.APPROVED) }})
      </button>
      <button type="button"
              class="btn btn-outline-primary me-1 btn-sm"
              (click)="updateSaleSubmissionFilter(saleHorseSubmissionsStatusIds.DRAFT,$event)"
              [ngClass]="{ active:  filter.draft }">
        Draft ({{ getFiltersCount(saleHorseSubmissionsStatusIds.DRAFT) }})
      </button>
      <button type="button"
              class="btn btn-outline-primary me-1 btn-sm"
              (click)="updateSaleSubmissionFilter(saleHorseSubmissionsStatusIds.PENDING,$event)"
              [ngClass]="{ active: filter.pending }">
        Pending ({{ getFiltersCount(saleHorseSubmissionsStatusIds.PENDING) }})
      </button>
      <button type="button"
              class="btn btn-outline-primary me-1 btn-sm"
              (click)="updateSaleSubmissionFilter(null,$event)"
              [ngClass]="{ active: filter.all }">
        All ({{  allSaleHorseCount }})
      </button>
    </div>
  </div>
  <!--  -->



  <div class="table-responsive data-grid sticky-header-table sticky-header-table-height-md mt-3 p-0"
       #table>
    <table mat-table="matTable"
           [dataSource]="dataSource"
           #matTable
           class="table table-hover"
           matSort="horseSort"
           infiniteScroll
           [infiniteScrollDistance]="1"
           [infiniteScrollThrottle]="20"
           [infiniteScrollContainer]="table"
           [fromRoot]="true"
           (scrolled)="onTableScroll()"
           [trackBy]="trackById">
      <ng-container matColumnDef="lotNumber">
        <th mat-header-cell class="w-4-rem" *matHeaderCellDef mat-sort-header>
          {{ lotOrHipText }} <i class="fa fa-sort ms-1"></i>
        </th>
        <td mat-cell
            *matCellDef="let element"
            class="cursor-pointer"
            (click)="openStudyFilePopupTrigger(element, $event)">
          <div class="hip-td-box text-success">{{ element?.lotNumber }} {{ element?.lotNumberSuffix }}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="horseName">
        <th mat-header-cell
            class="horse-name-heading cursor-pointer w-12-rem"
            *matHeaderCellDef
            mat-sort-header>
          <span (click)="sortTableOnHorse('horse')">
            Horse
            <i class="fas fa-sort me-2"></i>
          </span>
          <span (click)="sortTableOnHorse('sire')">
            Sire
            <i class="fas fa-sort me-2"></i>
          </span>
          <span (click)="sortTableOnHorse('dam')">
            Dam <i class="fas fa-sort"></i>
          </span>
        </th>
        <td mat-cell
            *matCellDef="let element"
            class="cursor-pointer"
            (click)="openStudyFilePopupTrigger(element, $event)">

            <app-horse-label [horse]="element"></app-horse-label>
          <!--<ng-container>
            <span>{{ element?.horseName }}</span>
          </ng-container>
          <span *ngIf="element?.isHorseNamed"
                class="sireAndDam"
                [ngClass]="{
                'text-gray': element?.isHorseNamed
              }">
            <br />
            {{ element?.sire }} x {{ element?.dam }}
          </span>-->
        </td>
      </ng-container>

      <ng-container matColumnDef="horseAgeCategoryName">
        <th mat-header-cell
            class="horse-age-category-heading cursor-pointer w-6-rem"
            *matHeaderCellDef
            mat-sort-header
            (click)="sortTable(saleHorseTableFields.HORSE_AGE_CATEGORY_NAME)">
          Type <i class="fa fa-sort ms-1"></i>
        </th>
        <td mat-cell
            *matCellDef="let element"
            class="cursor-pointer"
            (click)="openStudyFilePopupTrigger(element, $event)">
          {{ element.horseAgeCategoryName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="consignor">
        <th mat-header-cell
            class="consignor-heading cursor-pointer w-7-rem"
            *matHeaderCellDef
            mat-sort-header>
          Consignor <i class="fa fa-sort ms-1"></i>
        </th>
        <td mat-cell
            *matCellDef="let element"
            class="cursor-pointer"
            (click)="openStudyFilePopupTrigger(element, $event)">
          {{ element.consignor }}
        </td>
      </ng-container>

      <ng-container matColumnDef="accessionCode">
        <th mat-header-cell
            class="acc-no-heading cursor-pointer w-6-rem"
            *matHeaderCellDef
            mat-sort-header>
          ACC. NO <i class="fa fa-sort ms-1"></i>
        </th>
        <td mat-cell
            *matCellDef="let element"
            class="cursor-pointer"
            (click)="openStudyFilePopupTrigger(element, $event)">
          {{ element.accessionCode }}
        </td>
      </ng-container>

      <ng-container matColumnDef="submissionStatus">
        <th mat-header-cell
            class="status-heading cursor-pointer w-3-rem"
            *matHeaderCellDef
            mat-sort-header>
          Status <i class="fa fa-sort ms-1"></i>
        </th>
        <td mat-cell
            *matCellDef="let element"
            class="cursor-pointer"
            (click)="openStudyFilePopupTrigger(element, $event)">
          <div class="study-status-box study-status-box-{{
                element.submissionStatusId
              }}">
            {{ element.submissionStatus }}
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="xrayStatus">
        <th mat-header-cell
            class="xrayStatus-heading cursor-pointer w-4-rem"
            *matHeaderCellDef
            mat-sort-header>
          X-Ray Images <i class="fa fa-sort ms-1"></i>
        </th>
        <td mat-cell
            *matCellDef="let element"
            class="cursor-pointer"
            (click)="openStudyFilePopupTrigger(element, $event)">
          <div class="study-status-box study-status-box-{{
                element.xrayStatusId
              }}">
            {{ element.xrayStatus }}
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="scopeStatus">
        <th mat-header-cell
            class="scopeStatus-heading cursor-pointer w-3-rem"
            *matHeaderCellDef
            mat-sort-header>
          Scope <i class="fa fa-sort ms-1"></i>
        </th>
        <td mat-cell
            *matCellDef="let element"
            class="cursor-pointer"
            (click)="openStudyFilePopupTrigger(element, $event)">
          <div class="study-status-box study-status-box-{{
                element.scopeStatusId
              }}">
            {{ element.scopeStatus }}
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="xrayReportStatus">
        <th mat-header-cell
            class="xrayReportStatus-heading cursor-pointer w-3-rem"
            *matHeaderCellDef
            mat-sort-header>
          Report(s) <i class="fa fa-sort ms-1"></i>
        </th>
        <td mat-cell
            *matCellDef="let element"
            class="cursor-pointer"
            (click)="openStudyFilePopupTrigger(element, $event)">
          <div class="study-status-box study-status-box-{{
                element.xrayReportStatusId
              }}">
            {{ element.xrayReportStatus }}
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="saleResult">
        <th mat-header-cell
            class="saleResult-heading cursor-pointer w-7-rem"
            *matHeaderCellDef
            mat-sort-header>
          Result <i class="fa fa-sort ms-1"></i>
        </th>
        <td mat-cell
            *matCellDef="let element"
            class="cursor-pointer">
          <span (click)="openSaleHorseStatusPopupTrigger(element)"
                class="result-text"
                [class.text-danger]="
                element.saleResult === 'Withdrawn' ||
                element.saleResult === 'Withdrawn at Sale'
              "
                [class.text-success]="
                element.saleResult === 'Sold' ||
                element.saleResult === 'Private Sale'
              "
                [class.text-warning]="element.saleResult === 'Passed In'"
                *ngIf="element.saleResult != 'No Result'">{{ element.saleResult }}</span>
          <span class="result-text" *ngIf="element.saleResult == 'No Result'" (click)="openSaleHorseStatusPopupTrigger(element)">
            {{ !element.estimatedSaleTime ? "No Result" : element.estimatedSaleTime | date : getSaleDateFormat() }}

          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="notes" *ngIf="isSalesCompany">
        <th mat-header-cell
            class="xrayReportStatus-heading cursor-pointer w-1-rem"
            *matHeaderCellDef
            mat-sort-header>
          Notes <i class="fa fa-sort ms-1"></i>
        </th>

        <td mat-cell
            *matCellDef="let element"
            class="cursor-pointer"
            (click)="
              openInternalNotePopup(
                element.saleId,
                element.horseId,
                element.lot
              )
            ">
          <img src="assets/images/active-message.png"
               width="35"
               height="35"
               *ngIf="element.notesCount > 0" />
          <img src="assets/images/inactive-message.png"
               width="35"
               height="35"
               *ngIf="element.notesCount == 0" />
        </td>

        <td mat-cell
            *matCellDef="let element"
            class="cursor-pointer"
            (click)="
              openInternalNotePopup(
                element.saleId,
                element.horseId,
                element.lot
              )
            ">
          <img src="assets/images/active-message.png"
               width="35"
               height="35"
               *ngIf="element.notesCount > 0" />
          <img src="assets/images/inactive-message.png"
               width="35"
               height="35"
               *ngIf="element.notesCount == 0" />
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell
            class="action-heading w-1-rem"
            *matHeaderCellDef
            mat-sort-header></th>
        <td mat-cell
            *matCellDef="let element"
            ngbDropdown
            placement="start"
            class="custom-dropdown-menu text-right">
          <div class="dropdown-toggl cursor-pointer inline-element mr-10"
               id="action-dropdown"
               ngbDropdownToggle
               *ngIf="isSalesCompany">
            <i class="fas fa-ellipsis-v"></i>
          </div>
          <div class="action-dropdown fs-13"
               ngbDropdownMenu
               *ngIf="isSalesCompany"
               aria-labelledby="action-dropdown">
            <!--<button ngbDropdownItem *ngIf="element.submissionStatusId !== 0">
                          Activity Feed
                        </button>
                        <button
              [hidden]="!isSalesCompany"
              (click)="openInternalNotePopup(element.saleId, element.horseId,element.lot)"
              ngbDropdownItem
            >
              Add / View Notes
            </button>-->
            <!--<button
              ngbDropdownItem
              (click)="openScopeViewerPopup(element.saleId, element.horseId)"
            >
              Scope Viewer
            </button>
            <button
              ngbDropdownItem
              (click)="openXRayReportPopup(element.saleId, element.horseId)"
            >
              XRay Report
            </button>
            <button
              ngbDropdownItem
              (click)="
                viewStudy(
                  element.saleId,
                  element.horseId,
                  element.seriesInstanceUID
                )
              "
            >
              XRay Images
            </button>-->
            <button ngbDropdownItem
                    *ngIf="isSalesCompany"
                    (click)="openSaleHorseStatusPopupTrigger(element)">
              Edit Sale Result
            </button>
            <button ngbDropdownItem
                    *ngIf="isSalesCompany"
                    (click)="openEmailStudyDataPopup(element)">
              Share Data
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row
          *matHeaderRowDef="displayedColumns$.value; sticky: true"></tr>
      <tr mat-row
          *matRowDef="let row; columns: displayedColumns$.value;"  [hidden]="row.hidden"
          class="border-start-0 border-end-0 pointer pt-2"></tr>
    </table>
  </div>

</div>
